export const PARENT_ROLE = {
  partner: 'partner',
  consultant: 'partner',
  developer: 'partner',
  senior: 'partner',
  user: 'user',
  architect: 'user',
  reviewer: 'user',
  manufacturer: 'user',
  assistant: 'user',
};

export const CONSULTANCY_ROLES = [
  'partner',
  'consultant',
  'developer',
  'senior',
  'assistant',
  'reviewer',
];

export const COMPANY_ROLES = ['admin', 'user'];

export const COMPANY_CONTACT_ROLES = ['sales', 'support', 'marketing', 'rep', 'other'];
